import { createFileRoute } from "@tanstack/react-router";
import { TenantMineruConfig } from "@client/components/tenant-settings/parse-engine/tenant-mineru-config";

function isValidParseTab(v: unknown): v is "custom" | "system" {
  return v === "custom" || v === "system";
}

export const Route = createFileRoute("/_app/tenant-settings/parse-engines")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: isValidParseTab(search.tab) ? search.tab : "custom",
  }),
  component: TenantMineruConfig,
});
